module.exports = __webpack_public_path__ + "media/img/geo-f135956e8b976b32a6657b602fce16ba.svg";